import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import guestCardData from '../GuestView/GuestViewDashboardConstants';
import { useDispatch, useSelector } from 'react-redux';
import { resetScheduleCallWithAdvisor, scheduleCallWithAdvisor } from 'shared/Actions/MemberDashboardActions';
import { wealthOptions,timeWindows, timezones } from './Constants';
import { getTradingClosureWindow } from 'shared/Actions/TradingWindowActions';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
    addDays,
    startOfDay
} from "date-fns";
import { isDateAllowed , getEffectiveMinDate  } from 'utils/utils';
import { WSpinner } from 'common';

const autoStyle9 = {position:'absolute',right: '30px', top:'20px' };
const autoStyle10 = {width:'30px', cursor: 'pointer'};
const dateInputStyle = {
    height: '40px'
};

const SimpleWealthModal = ({ show, handleClose, isWealthManagerAvailable, wealthInformationData }) => {
    console.log('isWealthManagerAvailable',isWealthManagerAvailable)
    console.log('wealthInformationData',wealthInformationData)
    const [showPhoneNumber, setShowPhoneNumber] = useState(false);
    const [showScheduleForm, setShowScheduleForm] = useState(false);
    const [selectedPhone, setSelectedPhone] = useState('');
    const [selectedReason, setSelectedReason] = useState('');
    const [selectedPhoneInput, setSelectedPhoneInput] = useState('');
    const [phoneCountryCode,setPhoneCountryCode] = useState('+1');
    const [comments, setComments] = useState('');
    const [errors, setErrors] = useState({});
    const [errorMessage, setErrorMessage] = useState('');
    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedTimezone, setSelectedTimezone] = useState('');
    const [selectedTimeWindow, setSelectedTimeWindow] = useState('');
    const [isCalendarOpen, setIsCalendarOpen] = useState(false);
    const [isPhoneInputFocused, setIsPhoneInputFocused] = useState(false);
    const [isPhoneInputHovered, setIsPhoneInputHovered] = useState(false);
    const dispatch = useDispatch();
    const memberDashboardData = useSelector(state => state.memberDashboardData)
    const tradingWindowData = useSelector(state => state.tradingWindowData)
    const effectiveMinDate = getEffectiveMinDate(tradingWindowData?.secondBusinessDay);

    useEffect(() => {
        if (showScheduleForm && !tradingWindowData?.secondBusinessDay) {
            const token = localStorage?.getItem?.('token');
            if (token) {
                dispatch(getTradingClosureWindow({ token }));
            } else {
                console.warn('No token available to fetch trading closure window');
            }
        }
    }, [showScheduleForm, tradingWindowData?.secondBusinessDay, dispatch]);


    useEffect(() => {
        const token = localStorage?.getItem?.('token');
        if (token) {
            dispatch(getTradingClosureWindow({ token,ctaPopup: true }));
        } else {
            console.warn('No token available to fetch trading closure window');
        }
    },[])


    const handleCallVictoryClick = () => {
        setShowPhoneNumber(true);
        setShowScheduleForm(false);
    };

    const handleScheduleClick = () => {
        setShowPhoneNumber(false);
        setShowScheduleForm(true);
    };

    const handlePhoneChange = (e) => {
        setSelectedPhone(e.target.value);
        if(e.target.value != 'other') setSelectedPhoneInput('');
        setErrors(prev => ({ ...prev, phone: '' }));
    };

    const handleReasonChange = (e) => {
        setSelectedReason(e.target.value);
        if(e.target.value != 'other')  setComments("")
        setErrors(prev => ({ ...prev, reason: '' }));
    };

    const handlePhoneInputChange = (e) => {
        setSelectedPhoneInput(e.target.value);
        setErrors(prev => ({ ...prev, phoneInput: '' }));
    };

    const handleCommentsChange = (e) => {
        setComments(e.target.value);
    };


    const handlePhoneCountryCodeInputChange = (e) => {
            let countryCode  = e.target.value;
            console.log('countryCode', countryCode)
            // Remove all non-digits
            countryCode = countryCode.replace(/\D/g, '');
            setPhoneCountryCode(`+${countryCode}`);
    };


    // API Response
    const holidaysResponse = tradingWindowData?.holidays || [];

    // Convert all holiday dates into timestamps
    const holidayDates = Object.values(holidaysResponse)
        .flat()
        .map(item => {
            const [month, day, year] = item.date.split('/');
            return new Date(year, month - 1, day).setHours(0, 0, 0, 0);
        });


    const getMaskedPhoneInput = (phone) => {
        if (!phone) return '';
        if (phone.length <= 4) return phone;
        return phone.replace(/.(?=.{4})/g, 'X');
    };

    const getMaskedPhoneNumber = (phoneNumber) => {
            if (!phoneNumber) return '';

            const digits = phoneNumber.toString();

            if (digits.length <= 4) {
                return digits;
            }

            return digits.replace(/\d(?=(?:.*\d){4})/g, 'X');
    };

    const handlePhoneInputFocus = () => {
        setIsPhoneInputFocused(true);
    };

    const handlePhoneInputBlur = () => {
        setIsPhoneInputFocused(false);
    };

    const handlePhoneInputMouseEnter = () => {
        setIsPhoneInputHovered(true);
    };

    const handlePhoneInputMouseLeave = () => {
        setIsPhoneInputHovered(false);
    };
    // const validatePhoneNumber = (phone) => {
    //     const phoneRegex = /^[+]?[1-9][\d\-\s()]*$/;
    //     return phoneRegex.test(phone) && phone.replace(/[^\d]/g, '').length >= 10;
    // };

    // const handleDateChange = (date) => {
    //     setSelectedDate(date); // ✅ always keep value
    // };

    // const validateForm = () => {
    //     const newErrors = {};
        
    //     if (!selectedPhone) {
    //         newErrors.phone = 'Please select a phone number';
    //     }

    //     if (!selectedReason) {
    //         newErrors.reason = 'Please select a reason';
    //     }
        
    //     if (selectedPhone === 'other') {
    //         if (!selectedPhoneInput.trim()) {
    //             newErrors.phoneInput = 'Please enter a phone number';
    //         } else if (!validatePhoneNumber(selectedPhoneInput)) {
    //             newErrors.phoneInput = 'Please enter a valid phone number';
    //         }
    //     }
        
    //     setErrors(newErrors);
    //     return Object.keys(newErrors).length === 0;
    // };

    // const handleSubmitRequest = () => {
    //     if (!validateForm()) {
    //         return;
    //     }

    //     const phoneNumber = selectedPhone === 'other' ? selectedPhoneInput : selectedPhone;
    //     console.log('selectedPhone', phoneNumber)
    //     const payload = {
    //         phone_number: phoneNumber,
    //         selected_reason:selectedReason,
    //         comment: comments || ''
    //     }
    //     dispatch(scheduleCallWithAdvisor(payload));
    // }


    // useEffect(() => {
    //     console.log('memberDashboardData',memberDashboardData?.scheduleCallWithAdvisor)

    //     if(memberDashboardData?.scheduleCallWithAdvisorSuccess){
    //         handleClose()
    //     } else if(memberDashboardData?.scheduleCallWithAdvisorError){
    //         console.log('Modal detected error, showing error message');
    //         const errorMsg = 'Unable to submit at this time. Please contact a Wealth Specialist at 1-800-235-8396.';
    //         setErrorMessage(errorMsg);
            
    //         // Reset the error state so user can try again
    //         dispatch(resetScheduleCallWithAdvisor());
    //     }

    // }, [memberDashboardData, dispatch])
    
   // console.log('errorMessage', errorMessage)


    // Convert holidays into Set
    const holidayDatesSet = new Set(
        Object.values(holidaysResponse)
            .flat()
            .map(item => {
                const [month, day, year] = item.date.split('/');

                return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
            })
    );

    // Format helper
    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
    };

    // Weekend checker
    const isWeekend = (date) => {
        const day = date.getDay();

        return day === 0 || day === 6;
    };

    // Holiday checker
    const isHoliday = (date) => {
        return holidayDatesSet.has(formatDate(date));
    };

    // Generate blocked dates
    const getBlockedDates = () => {
        const blocked = new Set();

        const current = new Date();
        current.setHours(0, 0, 0, 0);

        // Always block today
        blocked.add(formatDate(current));

        let businessDaysCount = 0;

        while (businessDaysCount < 1) {
            current.setDate(current.getDate() + 1);

            const formatted = formatDate(current);

            // Always block weekends
            if (isWeekend(current)) {
                blocked.add(formatted);
                continue;
            }

            // Holiday counts as blocked business day
            if (isHoliday(current)) {
                blocked.add(formatted);

                businessDaysCount++;

                continue;
            }

            // Next valid business day
            blocked.add(formatted);

            businessDaysCount++;
        }

        // If ended on Friday holiday, continue blocking weekend
        while (isWeekend(current)) {
            current.setDate(current.getDate() + 1);

            blocked.add(formatDate(current));
        }

        return blocked;
    };

    const blockedDatesSet = getBlockedDates();


    const isLoading = tradingWindowData?.secondBusinessDay !="" ? false : true;

    return (
        <Modal show={show} onHide={handleClose} centered className='simpleWealthModal'>
            <WSpinner loading={isLoading }  />
            <div style={autoStyle9}>
                        <img src={'/assets/closeBlack.png'} data-testid="close-icon" style={autoStyle10} onClick={handleClose} />
            </div>
                 <h3 className='leftTitle'>{isWealthManagerAvailable ? guestCardData.connectMyWealthSpecialist : guestCardData.connectWealthSpecialist}</h3> 
                
            
            <Modal.Body>
                {!showPhoneNumber && !showScheduleForm && (
                    <>
                        <div className="d-flex justify-content-center">
                            <div onClick={handleCallVictoryClick} className="wealthmodalbtn px-4">
                                <i className='fa fa-phone'></i> Call Victory Capital
                            </div>
                        </div>
                        <div className="d-flex justify-content-center">
                            <div onClick={handleScheduleClick} className="wealthmodalbtn px-4">
                                <i className='fa fa-calendar'></i> Schedule a Call
                            </div>
                        </div>
                    </>
                )}
                
                {showPhoneNumber && (
                    <div>
                        <h4>Call Victory Capital</h4>
                        <p className="mb-0"><a href="tel:1-800-235-8396" className='linkText'>1-800-235-8396</a></p>
                    </div>
                )}

                {showScheduleForm && (
                    <div>
                        <h4>Schedule a Call</h4>
                        <div className='mb-3'>
                            <label className="form-label">Phone Number</label>
                            <select className={`form-select ${errors.phone ? 'is-invalid' : ''}`} value={selectedPhone} onChange={handlePhoneChange}>
                                <option value="">Select phone number</option>

                                {wealthInformationData?.phoneInformation?.map((phone, index) => (
                                    <option key={index} value={`${phone.phoneCountryCode}${phone.phoneNumber}`}>
                                        {phone.isPrimary ? 'Primary' : 'Secondary'}: {phone.phoneCountryCode} {getMaskedPhoneNumber(phone.phoneNumber)}
                                    </option>
                                ))}

                                <option value="other">Other</option>
                            </select>
                            {/* {errors.phone && (
                                <div className="invalid-feedback">{errors.phone}</div>
                            )} */}
                        </div>
                      

                        {selectedPhone === "other" && (
                            <div className="mb-3 d-flex gap-2"> 
                            <div style={{ width: "130px" }}>
                                <input 
                                    type="tel"
                                    className={`form-control ${errors.phoneInput ? 'is-invalid' : ''}`} 
                                    maxlength={phoneCountryCode.includes('+') ? 4 : 3} 
                                    // placeholder="country code" 
                                    value={phoneCountryCode}
                                    onChange={handlePhoneCountryCodeInputChange} 
                                />
                            </div>
                              <div className="flex-grow-1">
                                <input
                                    type="tel"
                                    className={`form-control ${errors.phoneInput ? 'is-invalid' : ''}`}
                                    placeholder="Enter your phone number"
                                    value={isPhoneInputFocused || isPhoneInputHovered ? selectedPhoneInput : getMaskedPhoneInput(selectedPhoneInput)}
                                    onChange={handlePhoneInputChange}
                                    onFocus={handlePhoneInputFocus}
                                    onBlur={handlePhoneInputBlur}
                                    onMouseEnter={handlePhoneInputMouseEnter}
                                    onMouseLeave={handlePhoneInputMouseLeave}
                                    pattern="[0-9+\-]+"
                                    onKeyPress={(e) => {
                                        const char = String.fromCharCode(e.which);
                                        if (!/[0-9+\-]/.test(char)) {
                                            e.preventDefault();
                                        }
                                    }}
                                />
                                {/* {errors.phoneInput && (
                                    <div className="invalid-feedback">{errors.phoneInput}</div>
                                )} */}
                            </div>
                            </div>
                        )}

                        
                        <div className='mb-3'>
                            <label className="form-label">How can we help?</label>
                            <select className={`form-select ${errors.reason ? 'is-invalid' : ''}`} value={selectedReason} onChange={handleReasonChange}>
                                <option value="">Select reason for call</option>

                                {wealthOptions?.map((reason, index) => (
                                    <option key={index} value={reason.name}>
                                        {reason.label}
                                    </option>
                                ))}

                                <option value="other">Other - Please specify</option>
                            </select>
                            {/* {errors.reason && (
                                <div className="invalid-feedback">{errors.reason}</div>
                            )} */}
                        </div>

                        {selectedReason === "other" && (
                            <div className="mb-3">
                                <label className="form-label">Tell us more</label>
                                <textarea 
                                    className="form-control" 
                                    placeholder="Briefly describe what you'd like to discuss" 
                                    rows="3"
                                    maxLength={100}
                                    value={comments}
                                    onChange={handleCommentsChange}
                                ></textarea>
                            </div>
                        )}

                        <div className='mb-3'>
                            <label className="form-label">Preferred Date</label>
                            <DatePicker
                                selected={selectedDate}
                                onChange={(date) => {
                                    setSelectedDate(date);
                                    setIsCalendarOpen(false);
                                }}
                                open={isCalendarOpen}
                                onInputClick={() => setIsCalendarOpen(true)}
                                onClickOutside={() => setIsCalendarOpen(false)}
                                shouldCloseOnSelect={true}
                                minDate={effectiveMinDate}
                                openToDate={effectiveMinDate}
                                filterDate={(date) => {
                                    const formattedDate = formatDate(date);

                                    if (isWeekend(date)) {
                                        return false;
                                    }

                                    if (holidayDatesSet.has(formattedDate)) {
                                        return false;
                                    }

                                    if (blockedDatesSet.has(formattedDate)) {
                                        return false;
                                    }

                                    return true;
                                }}
                                dateFormat="MM-dd-yyyy"
                                placeholderText="MM-DD-YYYY"
                                wrapperClassName="w-100"
                                autoComplete="off"
                                showPopperArrow={false}
                                onKeyDown={(e) => e.preventDefault()}
                                customInput={
                                    <input
                                        style={dateInputStyle}
                                        className={`form-control w-100 ${errors.date ? 'is-invalid' : ''}`}
                                    />
                                }
                            />
                            {/* {errors.date && (
                                <div className="invalid-feedback">{errors.date}</div>
                            )} */}
                        </div>

                        <div className='mb-3'>
                            <label className="form-label">Time Zone</label>

                           <select
                                className={`form-select ${errors.timezone ? 'is-invalid' : ''}`}
                                value={selectedTimezone}
                                onChange={(e) => setSelectedTimezone(e.target.value)}
                            >
                                <option value="">Select time zone</option>

                                {timezones?.map((zone, index) => (
                                    <option key={index} value={zone.value}>
                                        {zone.label}
                                    </option>
                                ))}
                            </select>

                            {/* {errors.timezone && (
                                <div className="invalid-feedback">{errors.timezone}</div>
                            )} */}
                        </div>

                        <div className='mb-3'>
                            <label className="form-label">Preferred Time Window</label>

                           <select
                                className={`form-select ${errors.timeWindow ? 'is-invalid' : ''}`}
                                value={selectedTimeWindow}
                                onChange={(e) => setSelectedTimeWindow(e.target.value)}
                            >
                                <option value="">Select time window</option>

                                {timeWindows?.map((time, index) => (
                                    <option key={index} value={time.value}>
                                        {time.label}
                                    </option>
                                ))}
                            </select>

                            {/* {errors.timeWindow && (
                                <div className="invalid-feedback">{errors.timeWindow}</div>
                            )} */}
                        </div>

                        <div className="d-flex justify-content-end gap-3">
                            <button className="btn btn-secondary" onClick={handleClose}>
                                Cancel
                            </button>
                            <button 
                                className="btn wealthSubmitBtn" 
                               // onClick={handleSubmitRequest}
                                 disabled
                            >
                                Submit
                            </button>
                        </div>
                        {/* {errorMessage && (
                            <div className="error-message">
                                <div className="alert alert-danger" role="alert">
                                    {errorMessage}
                                </div>
                            </div>
                        )} */}
                    </div>
                )}
            </Modal.Body>
        </Modal>
    );
};



export default SimpleWealthModal;
